import React from 'react';
import { Alert, AlertDescription, AlertTitle } from './ui/alert';
import { Button } from './ui/button';
import { RefreshCw } from 'lucide-react';

const UpdateNotification = () => {
  const [showUpdate, setShowUpdate] = React.useState(false);
  const [registration, setRegistration] = React.useState(null);

  React.useEffect(() => {
    // SERVICE WORKER DISABLED - Causing data caching issues
    // Service worker was serving stale API responses causing lead counts to jump
    // between different values (e.g., 59 → 183 → 59)
    // 
    // if ('serviceWorker' in navigator) {
    //   navigator.serviceWorker.register('/service-worker.js')
    //   ...
    // }
    console.log('⚠️ Service Worker disabled to prevent API caching issues');
  }, []);

  const handleUpdate = () => {
    if (registration && registration.waiting) {
      // Tell the service worker to skip waiting
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    }
  };

  if (!showUpdate) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50 max-w-md">
      <Alert className="border-blue-500 bg-blue-50">
        <RefreshCw className="h-4 w-4 text-blue-600" />
        <AlertTitle className="text-blue-900">Nouvelle version disponible!</AlertTitle>
        <AlertDescription className="text-blue-800">
          Une mise à jour est disponible. Cliquez pour actualiser l'application.
          <div className="mt-2">
            <Button 
              onClick={handleUpdate}
              size="sm"
              className="bg-blue-600 hover:bg-blue-700"
            >
              <RefreshCw className="h-3 w-3 mr-1" />
              Actualiser maintenant
            </Button>
          </div>
        </AlertDescription>
      </Alert>
    </div>
  );
};

export default UpdateNotification;
